<template>
  <form id="frm_action">
    <div class="p-formgrid row">
      <div class="col-lg-6">

        <div class="mt-2">
          <label class="txt-right">Permission name</label>
          <InputText
            v-model="name"
            id="name"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
            :disabled="true"
          />
        </div>

        <div class="mt-3">
          <label class="txt-right required">Người dùng</label>
        </div>

        <div class="d-flex align-items-center">
          <Dropdown 
            v-model="user"
            :options="filteredUsers"
            optionLabel="fullname"
            placeholder="Chọn"
            class="flex-grow-1 mr-2"
            style="flex: 0 0 90%;"/>
          <button type="button" class="btn btn-primary" @click="addRow" style="flex: 0 0 10%; background-color: transparent; color: red; font-weight: bold;">
            +
          </button>
          <input class="input_tmp_validator" id="user"/>
        </div>

        <div class="mt-3" v-if="selectedUsers.length > 0">
          <label class="txt-right" style="font-size: large;">SELECTED USER(S):</label>
          <div v-for="(user, index) in selectedUsers" :key="index" class="mt-3 d-flex align-items-center">
            <div style="flex: 0 0 50%;" class="d-flex align-items-center">
              <span style="flex: 0 0 95%;">{{ index + 1 }}. {{ user.fullname }}</span>
              <button
                type="button"
                class="btn btn-danger btn-sm ml-3"
                @click="deleteRow(index)"
                style="flex: 0 0 5%; padding: 0; border: none; background: none;">
                <i class="pi pi-trash" style="font-size: 1.2em; color: red;"></i>
              </button>
            </div>
            <div style="flex: 0 0 50%;"></div>
          </div>
        </div>

      </div>

          <Toolbar class="fixed-bottom-toolbar col-lg-12">
          <template slot="right">
            <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
            <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
import DataServices from "@/core/DataServices";
export default {
  props: {
    mode: String,
    model: Object,
    users: Array
  },
  data() {
    return {
      name: null,
      group_id: null,
      user: null,
      alreadyUsers: [],
      listUsers: [],
      listGroup: [],
      selectedUsers: [],
    };
  },
  async mounted() {
    // console.log("this.model", this.model);
    
    //get group_id
    const urlParams = new URLSearchParams(window.location.search);
    this.group_id = urlParams.get('group');

    //get group data
    await this.getGroupData();
    // console.log("this.listGroup", this.listGroup);
    this.name = this.listGroup[0].name;

    //get list users
    this.getListUsers();

    //get list already users
    await this.getListAlreadyUsers();
    // console.log("this.already_users", this.alreadyUsers);

    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.$commonFuction.is_loading(true);
      try {
       
        this.$commonFuction.is_loading(false);
      } catch(err) {
        console.log("Errrr", err);
        this.$commonFuction.is_loading(false);
      }
    }
  },
  computed: {
    filteredUsers() {
      return this.listUsers.filter(user => 
        !this.alreadyUsers.some(alreadyUser => alreadyUser.uid === user.id) &&
        !this.selectedUsers.some(selectedUser => selectedUser.id === user.id)
      );
    }
  },
  watch: {
  },
  methods: {
    backToList() {
      this.$emit("back", this.group_id);
    },

    async getGroupData() {
      var gqLQueryList = DataServices.getList("group", {"fields": "id, name, is_farm, farm_id"});
      var where = {
        active: {_eq: true},
        id: {_eq: this.group_id}
      }
      var resData = await this.$apollo.query({
        query: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: {name: "asc"}
        }
      })
      var listData = resData.data["group"];
      this.listGroup = listData;
    },

    async getListAlreadyUsers(){
      var gqLQueryList = DataServices.getList("group_user", {"fields": "id, uid"});
      var where = {
        group_id: {_eq: this.group_id}
      }
      var resData = await this.$apollo.query({
        query: gqLQueryList,
        variables: {
          where_key: where
        }
      })
      var listData = resData.data["group_user"];
      this.alreadyUsers = listData;
    },

    async getListUsers() {
      var gqLQueryList = DataServices.getList("users", {"fields": "id, fullname"});
      var where ={
        active: {_eq: true}
      }
      if (this.listGroup[0].is_farm == true) {
        where = {
          active: {_eq: true},
          farm_id: {_eq: this.listGroup[0].farm_id},
        }
      }
      var resData = await this.$apollo.query({
        query: gqLQueryList,
        variables: {
          where_key: where
        }
      })
      var listData = resData.data["users"];
      this.listUsers = listData;
    },

    async validateData() {
      this.validationErrors = {};

      
      let user_add = document.getElementById("user");
      if (this.selectedUsers.length == 0) {
        user_add.setCustomValidity("Vui lòng chọn ít nhất 1 người dùng!");
      } else {
        user_add.setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },

    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }
      // console.log("this.selectedUsers", this.selectedUsers);
      let user_id = this.$store.getters.user;
      var params = {
        group_id: this.group_id,
        created_by: user_id,
        users: this.selectedUsers.map(user => user.id)
      };
      // console.log("saveData", params);
      this.$emit("save", params);
    },

    addRow() {
      if (this.user) {
        this.selectedUsers.push(this.user);
        this.user = null;
      }
    },
    deleteRow(index) {
      this.selectedUsers.splice(index, 1);
    },
  },
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 480px;
  height: 270px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.p-multiselect-panel .p-checkbox.p-component {
  display: none !important;
}
</style>
